import BaseAPIService from './BaseAPIService';
import gql from 'graphql-tag';

export default class StoriesService extends BaseAPIService {
	constructor() {
		super();
	}

	getStory(id) {
		return new Promise((resolve, reject) => {
			const query = require('../graphql/queries/stories.gql');
			const variables = { id };
			this.query({ query, variables, fetchPolicy: 'network-only' })
				.then(result => {
					const returnData = result.data.story;
					resolve(returnData);
				})
				.catch(reject);
		});
	}

	createStory(input) {
        console.log(input);
		return new Promise((resolve, reject) => {
			if (input.position && input.position.latitude) {
				input.position.latitude = parseFloat(input.position.latitude);
			}

			if (input.position && input.position.longitude) {
				input.position.longitude = parseFloat(input.position.longitude);
			}

			delete input.id;

			const mutation = gql`
				mutation createStory($input: StoryInput!) {
					createStory(input: $input) {
						id
					}
				}
			`;
			const variables = { input };
			this.mutate({ mutation, variables })
				.then(result => {
					const returnData = result.data.createStory;
					resolve(returnData);
				})
				.catch(reject);
		});
	}

	updateStory(input) {
		return new Promise((resolve, reject) => {
			const mutation = gql`
				mutation updateStory($id: ID!, $input: StoryInput!) {
					updateStory(id: $id, input: $input) {
						id
					}
				}
			`;
			const id = input.id;
			delete input.id;
			const variables = {
				id,
				input
			};
			this.mutate({ mutation, variables })
				.then(result => {
					const returnData = result.data.updateStory;
					resolve(returnData);
				})
				.catch(reject);
		});
	}

	deleteStory(id) {
		return new Promise((resolve, reject) => {
			const mutation = gql`
				mutation deleteStory($id: ID!) {
					deleteStory(id: $id)
				}
			`;
			const variables = { id };
			this.mutate({ mutation, variables })
				.then(() => {
					resolve();
				})
				.catch(reject);
		});
	}
}
